import api, {deleteFn, getFn, IdApiArg, insertFn, UpdateArg, updateFn, UpdateResp} from "../../api";
import {Tables, TablesInsert, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export interface InterruptFilter {
    active?: boolean
}


export const intrApi = api.injectEndpoints({

    endpoints: (build) => ({

        getInterrupt: build.query<Tables<"interrupt">[], InterruptFilter>({
            queryFn: async (args) => {
                const q = supabase
                    .from("interrupt")
                    .select("*")

                if (args.active === true || args.active === false) {
                    q.eq("Active", args.active)
                }
                const {data, error} = await q;

                if (error) return {error};
                return {data}
            },
            providesTags: ["Interrupt"]
        }),
        getInterruptById: build.query<Tables<"interrupt"> | null, IdApiArg>({
            query: getFn("interrupt"),
            providesTags: ["Interrupt"]
        }),
        postInterrupt: build.mutation<UpdateResp, TablesInsert<"interrupt">>({
            query: insertFn("interrupt"),
            invalidatesTags: ["Interrupt"],
        }),
        deleteInterruptById: build.mutation<UpdateResp, IdApiArg>({
            query: deleteFn("interrupt"),
            invalidatesTags: ["Interrupt"],
        }),
        putInterruptById: build.mutation<UpdateResp, UpdateArg<"interrupt">>({
            query: updateFn("interrupt"),
            invalidatesTags: ["Interrupt"],
        }),
    })
});

export type IntrApiPut = TablesInsert<"interrupt">

export type IntrApiGet = Tables<"interrupt">


export const {

    useGetInterruptQuery,
    useGetInterruptByIdQuery,
    usePostInterruptMutation,
    usePutInterruptByIdMutation,
    useDeleteInterruptByIdMutation,

} = intrApi;
